import type Transaction from '~/types/Transaction';

import { ActionKeys } from './constants';

export const fetchTransaction = (transactionId: string) =>
  <const>{
    payload: {
      transactionId,
    },
    type: ActionKeys.FETCH_TRANSACTION,
  };

export const fetchTransactionSuccess = (transaction: Transaction) =>
  <const>{
    payload: {
      transaction,
    },
    type: ActionKeys.FETCH_TRANSACTION_SUCCESS,
  };

export const fetchTransactionError = () =>
  <const>{
    type: ActionKeys.FETCH_TRANSACTION_ERROR,
  };

export const sendEmailNotification = (transactionId: string) =>
  <const>{
    payload: {
      transactionId,
    },
    type: ActionKeys.SEND_EMAIL_NOTIFICATION,
  };

export const sendEmailNotificationSuccess = () =>
  <const>{
    type: ActionKeys.SEND_EMAIL_NOTIFICATION_SUCCESS,
  };

export const sendEmailNotificationError = () =>
  <const>{
    type: ActionKeys.SEND_EMAIL_NOTIFICATION_ERROR,
  };

export const updateSuccessfulTransactionsCount = (count: number) =>
  <const>{
    payload: {
      count,
    },
    type: ActionKeys.UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT,
  };

export const updateFirstSuccessfulTransactionObjectId = (objectId: string) =>
  <const>{
    payload: {
      objectId,
    },
    type: ActionKeys.UPDATE_FIRST_SUCCESSFUL_TRANSACTION_OBJECT_ID,
  };

export type TransactionsActions =
  | ReturnType<typeof fetchTransaction>
  | ReturnType<typeof fetchTransactionError>
  | ReturnType<typeof fetchTransactionSuccess>
  | ReturnType<typeof sendEmailNotification>
  | ReturnType<typeof sendEmailNotificationError>
  | ReturnType<typeof sendEmailNotificationSuccess>
  | ReturnType<typeof updateFirstSuccessfulTransactionObjectId>
  | ReturnType<typeof updateSuccessfulTransactionsCount>;
